import { FormSelect } from '@shared/ui';
import { REQUIRED_CANDIDATES_COUNT_OPTIONS } from './constants';
import type { ComponentProps } from 'react';

type VacancyCandidatesCountProps = Omit<
  ComponentProps<typeof FormSelect>,
  'data' | 'title' | 'description' | 'placeholder'
>;

export const VacancyCandidatesCount = (props: VacancyCandidatesCountProps) => {
  return (
    <FormSelect
      {...props}
      data={REQUIRED_CANDIDATES_COUNT_OPTIONS}
      title='Кол-во вакантных мест'
      description='Установите число кандидатов, предлагаемых для вакансии'
      placeholder='Выберите'
    />
  );
};
